import React, { PureComponent } from 'react'
import { Button, Form,Input,Select} from 'antd'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { getData } from '../../api/api'
import { getRandomN } from '../../utils/tool'
import instance from '../../api/bankRequest'
const { Option } = Select

@observer
class Home extends PureComponent {
	@observable dataInfo = ''
	@observable mbrCode = '0154100004437366'

	onSubmit = () =>{
		const param = {
			trxCode:'300012',
			mbrCode:this.mbrCode,
			operType:'1',
			mercJrnno:getRandomN(),
			pageRetUrl:'http://teruo-home.gdhttech.com/pay/withdrawPage',
			bgRetUrl:'http://teruo-home.gdhttech.com/pay/withdrawPage'
		}
		getData(param).then(res =>{
			this.dataInfo = res.data.split('&')
			document.forms[0].submit();
		})
	}

	render() {
		const { dataInfo } = this
		return (
			<div className="page_content">
				<div className='title'>
					<span>自动提现申请</span>
					<Button type='primary' className='back' onClick={() => window.history.back(-1)}>返回</Button>
				</div>
				<div className='desc'>授权申请说明:授权平台自动提现后，平台可以将用户的电子登记簿资金(全额或部分)提现至绑定的银行账户。</div>
				<div className='select'>
					<span>存管系统用户编号：</span>
					<Select style={{width:300}} onChange={(v) =>{
						this.mbrCode=v
						console.log(v)}}
						placeholder='请选择存管系统用户编号'
						defaultValue={'0154100004437366'}
					>
						<Option value={'0154100004437366'} key={'1'}>0154100004437366（慧途）</Option>
					</Select>
				</div>
				<div style={{textAlign:'center'}}>
					<Button type='primary' className='btn' onClick={this.onSubmit}>申请自动提现</Button>
				</div>
				<Form method='post' action={instance.baseURL+'/bhdep/payTransactionNew'} style={{display:'none'}} >
                    <Input type='text' name='INFO' value={dataInfo? dataInfo[0].substring(5):''}/>
                    <Input type='text' name='BODY' value={dataInfo? dataInfo[1].substring(5):''}/>
                    <Input type='text' name='SIGN' value={dataInfo? dataInfo[2].substring(5):''}/>
                    <Input type='text' name='CONTENTTYPE' value='json'/>
                    <Input type='submit' value='提交' />
                </Form>
			</div>
		)
	}
}
export default Home
